{
    "consumer_nav_home": {
        "defaultMessage": "Home",
        "description": "Navigation item for Home"
    },
    "consumer_nav_news": {
        "defaultMessage": "News",
        "description": "Navigation item for News"
    },
    "consumer_nav_profile": {
        "defaultMessage": "Profile",
        "description": "Navigation item for Profile"
    },
    "consumer_nav_logout": {
        "defaultMessage": "Logout",
        "description": "Navigation item for Logout"
    },
    "consumer_nav_back": {
        "defaultMessage": "Back",
        "description": "Navigation item for Back"
    },
    "consumer_nav_refresh": {
        "defaultMessage": "Refresh",
        "description": "Navigation item for Home"
    },
    "consumer_nav_share": {
        "defaultMessage": "Share",
        "description": "Navigation item for Share"
    },
    "consumer_nav_download": {
        "defaultMessage": "Download",
        "description": "Navigation item for Download"
    },
    "consumer_nav_print_store": {
        "defaultMessage": "Print Store",
        "description": "Navigation item for Print Store"
    },
    "consumer_nav_add_photos": {
        "defaultMessage": "Add Photos",
        "description": "Navigation item for Adding Photos"
    },
    "consumer_nav_add_photos_mobile": {
        "defaultMessage": "Add",
        "description": "Navigation item for Adding Photos on Mobile"
    },
    "consumer_footer_text": {
        "defaultMessage": "WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)",
        "description": "Message displayed at the bottom"
    },
    "consumer_login_message": {
        "defaultMessage": "Let`s get back to capturing those moments!",
        "description": "Label for Login message"
    },
    "consumer_forgot_password": {
        "defaultMessage": "Enter your email address or phone number to reset your password",
        "description": "Label for forgot password"
    },
    "consumer_update_email": {
        "defaultMessage": "Please enter the email and password that you would like to use.",
        "description": "Label for message to user to advice to put the email they want to"
    },
    "consumer_link_expired": {
        "defaultMessage": "Sorry, this link has expired. Please enter your email or phone number to receive another link.",
        "description": "Label for message to advise that the link is expired and put details to receive another link"
    },
    "consumer_missing_something_error": {
        "defaultMessage": "Oops, looks like you`re missing something.",
        "description": "Label for message that says something is missing from user input"
    },
    "consumer_enter_valid_email_phone": {
        "defaultMessage": "Please enter a valid email address or phone number.",
        "description": "Label for message to enter a valid email or phone number"
    },
    "consumer_enter_email": {
        "defaultMessage": "Please enter an email address.",
        "description": "Label for message for user to enter email address"
    },
    "consumer_enter_password": {
        "defaultMessage": "Please enter a password.",
        "description": "Label for message for user to enter password"
    },
    "consumer_confirm_password": {
        "defaultMessage": "Enter and Please confirm your password.",
        "description": "Label for message for user to enter and confirm password"
    },
    "consumer_passwords_dont_match": {
        "defaultMessage": "Your password and password confirmation don`t match.",
        "description": "Label for message for user that passwords don't match"
    },
    "consumer_password_alteast_length": {
        "defaultMessage": "Your password must be at least {count} characters.",
        "description": "Label for message for user to input password with atleast length count required"
    },
    "consumer_email_placeholder": {
        "defaultMessage": "Email",
        "description": "Label for Email placeholder"
    },
    "consumer_password_placeholder": {
        "defaultMessage": "Password",
        "description": "Label for Password placeholder"
    },
    "consumer_welcome_back": {
        "defaultMessage": "Welcome Back!",
        "description": "Label for Welcome back message"
    },
    "consumer_agreement": {
        "defaultMessage": "By using Capturelife you agree to our ",
        "description": "Label for initial agreement phrase"
    },
    "consumer_terms_of_use": {
        "defaultMessage": "Terms of use",
        "description": "Label for Term of use word"
    },
    "consumer_contact_us": {
        "defaultMessage": "Contact Us",
        "description": "Label for Contact Us button"
    },
    "consumer_my_personal_data": {
        "defaultMessage": "My Personal Data",
        "description": "Label for Personal Data button"
    },
    "consumer_item_generate_qr_code": {
        "defaultMessage": "Generate QR Code",
        "description": "Label for QR Code button"
    },
    "consumer_email_or_phone": {
        "defaultMessage": "Email or phone",
        "description": "Label for Email or phone word"
    },
    "consumer_email_or_phone_long": {
        "defaultMessage": "Email address or phone number",
        "description": "Label for Email address or phone number"
    },
    "consumer_resetting_password": {
        "defaultMessage": "Resetting password...",
        "description": "Label for message of reset password progress"
    },
    "consumer_reset_password": {
        "defaultMessage": "Reset Password",
        "description": "Label for reset password word"
    },
    "consumer_forgot_your_password": {
        "defaultMessage": "Forgot your Password?",
        "description": "Label for Forgot password message"
    },
    "consumer_update_your_password": {
        "defaultMessage": "Update your password",
        "description": "Label for Update Password action"
    },
    "consumer_confirm_your_password": {
        "defaultMessage": "Password Confirmation",
        "description": "Label for Password Confirmation"
    },
    "consumer_updating_password": {
        "defaultMessage": "Updating password...",
        "description": "Label for update password progress"
    },
    "consumer_update_password": {
        "defaultMessage": "Update password",
        "description": "Label for Update password action"
    },
    "consumer_logging_in": {
        "defaultMessage": "Logging in...",
        "description": "Label for Login progress"
    },
    "consumer_select_all": {
        "defaultMessage": "Select All",
        "description": "Description for toggle to select all photos"
    },
    "consumer_qr_text": {
        "defaultMessage": "Please take a screenshot of your QR Code or click Download button below",
        "description": "Instructions to save the displayed QR code in some way"
    },
    "consumer_share_dialog_notes": {
        "defaultMessage": "To download or share an image, long tap the image to bring up your device`s share options.",
        "description": "Instruction for user on how to download or share an image"
    },
    "consumer_store_title": {
        "defaultMessage": "Online Shop",
        "description": "Label for Store Title"
    },
    "consumer_image_view_print_store": {
        "defaultMessage": "Print Store",
        "description": "Label for Print Store"
    },
    "consumer_selfie_instructions": {
        "defaultMessage": "Upload a selfie to get started",
        "description": "Instructions prompting user to upload a selfie"
    },
    "consumer_selfie_button": {
        "defaultMessage": "Choose a selfie",
        "description": "Label for selfie upload button"
    },
    "consumer_take_photo_button": {
        "defaultMessage": "Take a Photo",
        "description": "Label for selfie upload button"
    },
    "consumer_retake_photo_button": {
        "defaultMessage": "Take a Photo",
        "description": "Label for selfie upload button"
    },
    "consumer_search_photo_button": {
        "defaultMessage": "Search for photos",
        "description": "Label for selfie upload button"
    },
    "consumer_selfie_upload_in_progress": {
        "defaultMessage": "Upload in progress",
        "description": "Message for when a selfie is being uploaded"
    },
    "consumer_selfie_upload_complete": {
        "defaultMessage": "Selfie successfully uploaded",
        "description": "Message for when a selfie has been uploaded"
    },
    "consumer_selfie_upload_failed": {
        "defaultMessage": "An error occurred.  Please try again",
        "description": "Message for when a selfie failed to be uploaded"
    }
}